import React, { useEffect, useState } from 'react';
import './PostPage.css';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { formatISO9075 } from 'date-fns';
import { SectionWrap } from '../../Components';
import { CiCalendarDate } from "react-icons/ci";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import LoadingPage from '../LoadingPage/LoadingPage';

function PostPage() {
  // const apiUrl = 'http://localhost/server/testServer';
  const apiUrl = 'https://www.albarede.com/server';
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const [postInfo, setPostInfo] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    fetch(`${apiUrl}/post.php?id=${id}`)
      .then(response => response.json())
      .then(postInfo => setPostInfo(postInfo))
      .catch(error => console.error('Error fetching post:', error));
  }, [id]);

  if (!postInfo) return <LoadingPage/>;

  // تقسيم سلسلة الوسوم إلى مصفوفة (إذا كانت موجودة)
  const tagsArray = postInfo.tags ? postInfo.tags.split(',').map(tag => tag.trim()) : [];

  return (
    <div className="postPage">
      <div className="image">
        <img src={`${apiUrl}/${postInfo.files}`} alt="Post" />
      </div>
      <div className='containerNew'>
        <SectionWrap>
        <h1>{postInfo.title}</h1>
        <div className="postInfoTime">
          <div>
            <HiOutlinePencilSquare />
            <p className="author">{postInfo.author}</p>
          </div>
          <div>
            <CiCalendarDate />
            <time className="time">{formatISO9075(new Date(postInfo.createAt))}</time>
          </div>
        </div>
        {isLoggedIn && (
          <div className="editDeleteOptions">
            <Link to={`/edit/${postInfo.id}`} className="editBtnPost">تعديل المقال</Link>
          </div>
        )}
        <p className="summaryPost">{postInfo.summary}</p>
        <div className="postText" dangerouslySetInnerHTML={{ __html: postInfo.content }} />

        {/* قسم عرض الوسوم الآن كروابط */}
        {tagsArray.length > 0 && (
          <div className="postTags">
            <h3>الوسوم:</h3>
            <div className="tagsContainer">
              {tagsArray.map((tag, index) => (
                <Link to={`/tags/${encodeURIComponent(tag)}`} key={index} className="tagLink" target='_top'>
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        )}

        <div style={{display: 'none'}} id="google_translate_element"></div>
      </SectionWrap>
      </div>
    </div>
  );
}

export default PostPage;